import { createSlice } from "@reduxjs/toolkit";

export const dataSlice = createSlice({
  name: "data",
  initialState: {
    sidebarData: null,
    profilePicNav: true,
    newsData: null,
    hiddenNews: [],
    search: "",
    searchFilter: { name: "All time", value: "" },
    bookmarkUrls: [],
    bookmarkData: {},
    newBookmarkPopup: false,
    summarizePopup: false,
    collections: [],
    selectedCollection: {},
    eventName: null,
    datePicker: false,
    fromDate: null,
    toDate: null,
    showCharity: true,
    showTitleRedirect: { popup: true, title: "" },
    summaryInfoData: { publisher: "", title: "", published_date: "", url: "" },
    articleSummary: "",
    summaryPopup: false,
    citationPopup: false,
    bookmarkArticle: false,
    articleDataCitation: {},
    citationData: "",
    url: "",
    changeEmailPopup: false,
    academiaSearch: "",
    microsoftUser: false,
    academiaSearchList: [],
    academiaData: {},
    bookmarkCategory: null,
    academiaHeaderUrl: "",
    sidebarDataCopy: null,
    profilePicUrl: "",
    itemTypes: {},
  },
  reducers: {
    setsidebarData: (state, action) => {
      const { payload } = action;

      state.sidebarData = payload;
    },
    setnewsData: (state, action) => {
      const { payload } = action;

      state.newsData = payload;
    },
    sethiddenNews: (state, action) => {
      const { payload } = action;

      state.hiddenNews = payload;
    },
    setsearch: (state, action) => {
      const { payload } = action;

      state.search = payload;
    },
    setsearchFilter: (state, action) => {
      const { payload } = action;

      state.searchFilter = payload;
    },
    setBookmarkUrls: (state, action) => {
      const { payload } = action;

      state.bookmarkUrls = payload;
    },
    setBookmarkData: (state, action) => {
      const { payload } = action;

      state.bookmarkData = payload;
    },
    setNewBookmarkPopup: (state, action) => {
      const { payload } = action;

      state.bookmarkData = payload;
    },
    setCollections: (state, action) => {
      const { payload } = action;

      state.collections = payload;
    },
    setSelectedCollection: (state, action) => {
      const { payload } = action;

      state.collections = payload;
    },
    setEventName: (state, action) => {
      const { payload } = action;

      state.eventName = payload;
    },
    setDatePicker: (state, action) => {
      const { payload } = action;

      state.datePicker = payload;
    },
    setFromDate: (state, action) => {
      const { payload } = action;
      state.fromDate = payload;
    },
    setToDate: (state, action) => {
      const { payload } = action;
      state.toDate = payload;
    },
    setShowCharity: (state, action) => {
      const { payload } = action;
      state.showCharity = payload;
    },
    setSummarizePopup: (state, action) => {
      const { payload } = action;
      state.summarizePopup = payload;
    },
    setUrl: (state, action) => {
      const { payload } = action;
      state.url = payload;
    },
    setShowTitleRedirectPopup: (state, action) => {
      const { payload } = action;
      state.showTitleRedirect = payload;
    },
    setSummaryInfoData: (state, action) => {
      const { payload } = action;
      state.summaryInfoData = payload;
    },
    setArticleSummary: (state, action) => {
      const { payload } = action;
      state.articleSummary = payload;
    },
    setSummaryPopup: (state, action) => {
      const { payload } = action;
      state.summaryPopup = payload;
    },
    setCitationPopup: (state, action) => {
      const { payload } = action;
      state.citationPopup = payload;
    },
    setBookmarkArticle: (state, action) => {
      const { payload } = action;
      state.bookmarkArticle = payload;
    },
    setArticleDataCitation: (state, action) => {
      const { payload } = action;
      state.articleDataCitation = payload;
    },
    setCitationData: (state, action) => {
      const { payload } = action;
      state.citationData = payload;
    },
    setChangeEmailPopup: (state, action) => {
      const { payload } = action;
      state.changeEmailPopup = payload;
    },
    setProfilePicNav: (state, action) => {
      const { payload } = action;
      state.profilePicNav = payload;
    },
    setAcademiaSearch: (state, action) => {
      const { payload } = action;
      state.academiaSearch = payload;
    },
    setMicrosoftUser: (state, action) => {
      const { payload } = action;
      state.microsoftUser = payload;
    },
    setAcademiaSearchList: (state, action) => {
      const { payload } = action;
      state.academiaSearchList = payload;
    },
    setAcademiaData: (state, action) => {
      const { payload } = action;
      state.academiaData = payload;
    },
    setBookmarkCategory: (state, action) => {
      const { payload } = action;
      state.bookmarkCategory = payload;
    },
    setAcademiaHeaderUrl: (state, action) => {
      const { payload } = action;
      state.academiaHeaderUrl = payload;
    },
    setsidebarDataCopy: (state, action) => {
      const { payload } = action;

      state.sidebarDataCopy = payload;
    },
    setProfilePicUrl: (state, action) => {
      const { payload } = action;

      state.profilePicUrl = payload;
    },
    setItemsPage: (state, action) => {
      const { payload } = action;

      state.itemTypes = payload;
    },
  },
});

// this is for dispatch
export const {
  setsidebarData,
  setnewsData,
  sethiddenNews,
  setsearch,
  setsearchFilter,
  setBookmarkUrls,
  setBookmarkData,
  setCollections,
  setSelectedCollection,
  setEventName,
  setDatePicker,
  setToDate,
  setFromDate,
  setShowCharity,
  setSummarizePopup,
  setUrl,
  setShowTitleRedirectPopup,
  setSummaryInfoData,
  setArticleSummary,
  setSummaryPopup,
  setCitationPopup,
  setBookmarkArticle,
  setArticleDataCitation,
  setCitationData,
  setChangeEmailPopup,
  setProfilePicNav,
  setAcademiaSearch,
  setMicrosoftUser,
  setAcademiaSearchList,
  setAcademiaData,
  setBookmarkCategory,
  setAcademiaHeaderUrl,
  setsidebarDataCopy,
  setProfilePicUrl,
  setItemsPage,
} = dataSlice.actions;

// this is for configureStore
export default dataSlice.reducer;
